import Panel from '../../apricot/Panel';
import { numberFormat } from '../../../numeral';
import styles from '../../../../sass/status.module.scss';
export default (function (props) {
  var PanelBody = function PanelBody(_ref) {
    var _ref$numberStudentsEn = _ref.numberStudentsEnrolled,
      numberStudentsEnrolled = _ref$numberStudentsEn === void 0 ? 0 : _ref$numberStudentsEn,
      _ref$numberEnrollment = _ref.numberEnrollments,
      numberEnrollments = _ref$numberEnrollment === void 0 ? 0 : _ref$numberEnrollment;
    return /*#__PURE__*/React.createElement("div", {
      className: styles['status-panel-container']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['status-panel-border']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['status-title']
    }, "Students"), /*#__PURE__*/React.createElement("div", {
      className: styles['status-number']
    }, numberFormat(numberStudentsEnrolled))), /*#__PURE__*/React.createElement("div", {
      className: styles['status-panel-border']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['status-title']
    }, "Enrollments"), /*#__PURE__*/React.createElement("div", {
      className: styles['status-number']
    }, numberFormat(numberEnrollments))));
  };
  return /*#__PURE__*/React.createElement(Panel, {
    title: "Student Registrations",
    body: /*#__PURE__*/React.createElement(PanelBody, props)
  });
});